module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[24]267.347c657.woff2";